import React, { useState, useEffect } from 'react';

// Components
import Breadcrumbs from '../../../components/Breadcrumbs';

// Utils
import {
    getDataWithComp,
    getAlert,
    formatCurrency
} from '../../../../utils/SamuiUtils';

import {
    formatDateAndTime,
} from '../../../../utils/DateUtils';

function Form({ name }) {
    const [formArList, setFormArList] = useState([]);
    const [formItemHistory, setFormItemHistory] = useState([]);
    const [arId, setArId] = useState(null);

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        try {
            // ค้นหาข้อมูลตั้งต้นจาก API_0002_Set_Item
            const arList = await getDataWithComp('API_1401_WH_ARPAYMENT_ONHAND', `ORDER BY AR_Code ASC`);
            if (arList && arList.length > 0) {
                setFormArList(arList);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
        }
    };

    // API_1501_WH_ARPAYMENT_STC (ประวัติการชําระเงิน)
    const onRowSelectHistory = async (arId) => {
        try {
            setArId(arId);

            setFormItemHistory([]);

            const itemHistory = await getDataWithComp('API_1501_WH_ARPAYMENT_STC', `AND Item_Id = ${arId} ORDER BY STC_SEQ DESC`);

            if (itemHistory && itemHistory.length > 0) {
                setFormItemHistory(itemHistory);
            }
        } catch (error) {
            getAlert('FAILED', error.message);
            setFormItemHistory([]);
        }
    };

    // ใช้สำหรับค้นหาลูกค้า
    const [searchTerm, setSearchTerm] = useState('');
    // ฟังก์ชันสำหรับกรองข้อมูล
    const filteredArList = formArList.filter((item) =>
        item.AR_Code.includes(searchTerm) || item.AR_Name.includes(searchTerm)
    );

    return (
        <>
            <Breadcrumbs page={'ตรวจสอบค้างจ่าย'} items={[
                { name: 'งานบัญชี', url: '/account' },
                { name: name, url: '/payment-stock' },
                { name: "สร้าง" + name, url: '#' },
            ]} />
            <div className="row mt-1 hidden-scrollbar" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                <div className="col-4">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="container-fluid">
                                    <div className="d-flex flex-row justify-content-between align-items-center">
                                        <h5 className="card-title mt-3 me-4 text-center">ลูกค้าทั้งหมด</h5>
                                        <div className="input-group" style={{ maxWidth: "300px" }}>
                                            <span className="input-group-text">Search</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value);
                                                }}
                                                placeholder="ค้นหา รหัสลูกค้า หรือ ชื่อลูกค้า"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive" style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                    <table id="basic-datatables" className="table table-striped table-hover">
                                        <thead className="thead-dark">
                                            <tr>
                                                <th className="text-center" style={{ width: '1%' }}>#</th>
                                                <th className="text-center" style={{ width: '17%' }}>รหัสลูกค้า</th>
                                                <th className="text-center" style={{ width: '60%' }}>ชื่อลูกค้า</th>
                                                <th className="text-center" style={{ width: '22%' }}>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredArList.length > 0 ? (
                                                filteredArList.map((item, index) => (
                                                    <tr
                                                        key={item.AR_Id}
                                                        onClick={() => {
                                                            onRowSelectHistory(item.AR_Id);
                                                        }}
                                                        style={{
                                                            cursor: 'pointer',
                                                            backgroundColor: arId === item.AR_Id ? 'rgb(105, 188, 216)' : 'transparent',
                                                            transition: 'background-color 0.3s ease'
                                                        }}
                                                    >
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{item.AR_Code}</td>
                                                        <td className="text-left">{item.AR_Name}</td>
                                                        <td
                                                            className="text-end"
                                                            style={{
                                                                color: item.Item_Onhand < 0 ? 'red' : item.Item_Onhand > 0 ? 'green' : 'inherit',
                                                                fontWeight: 'bold'
                                                            }}
                                                        >
                                                            {formatCurrency(item.Item_Onhand)}
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={7}>
                                                        <center>
                                                            <h5>ไม่พบข้อมูล</h5>
                                                        </center>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-8">
                    <div className={`tab-pane fade show active`} role="tabpanel">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="container-fluid">
                                        <div className="d-flex flex-row">
                                            <h5 className="card-title mt-3 me-4 text-center">ประวัติยอดเงินเคลื่อนไหว</h5>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <table id="basic-datatables" className="table table-striped table-hover">
                                            <thead className="thead-dark">
                                                <tr>
                                                    <th className="text-center" style={{ width: '1%' }}>#</th>
                                                    <th className="text-center" style={{ width: '14%' }}>ประเภท</th>
                                                    <th className="text-center" style={{ width: '15%' }}>จำนวน</th>
                                                    <th className="text-center" style={{ width: '15%' }}>ยอดเงินคงเหลือ</th>
                                                    <th className="text-center" style={{ width: '15%' }}>วันที่ทำรายการ</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เลขเอกสาร</th>
                                                    <th className="text-center" style={{ width: '10%' }}>เอกสารอ้างอิง</th>
                                                    <th className="text-center" style={{ width: '20%' }}>หมายเหตุ</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formItemHistory.length > 0 ? (
                                                    formItemHistory.map((item, index) => (
                                                        <tr key={item.STC_Id}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">{item.Doc_Type === 'AO' ? 'ค้างจ่าย' : 'จ่ายแล้ว'}</td>
                                                            <td className="text-center">
                                                                {
                                                                    item.Doc_Type === 'TO'
                                                                        || item.Doc_Type === 'AO'
                                                                        || item.Doc_Type === 'OUT' ? '-' : ''
                                                                }
                                                                {formatCurrency(item.STC_QTY)}
                                                            </td>
                                                            <td className="text-center">{formatCurrency(item.STC_Balance)}</td>
                                                            <td className="text-center">{formatDateAndTime(item.STC_Date)}</td>
                                                            <td className="text-center">{item.Doc_No}</td>
                                                            <td className="text-center">
                                                                {item.Doc_NoRef && item.Doc_NoRef.split('ยกเลิก').map((part, index, array) => (
                                                                    <React.Fragment key={index}>
                                                                        {part}
                                                                        {index < array.length - 1 && (
                                                                            <span style={{ color: 'red', fontWeight: 'bold' }}>
                                                                                <strong>ยกเลิก</strong>
                                                                            </span>
                                                                        )}
                                                                    </React.Fragment>
                                                                ))}
                                                            </td>
                                                            <td className="text-center">{item.STC_Remark || '-'}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <center>
                                                                <h5>ไม่พบข้อมูล</h5>
                                                            </center>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Form;